var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('img',{staticClass:"content",attrs:{"src":require("../assets/courseIntro.png"),"alt":""}})])
}]

export { render, staticRenderFns }